import { useState } from "react";
import { MdDelete } from "react-icons/md";
import { NumberFormatter } from "../../../../../CommonFunction/common";
import { Confirm } from "../../../Confirmation/Confirm";

const headers = ["Name", "Transaction_Type", "Rate", "Amount"];
export const SalesBillFormulaTable = ({ el, index, handleDelete, handleFormulaChange }) => {
  const [deleteState, setDeleteState] = useState(false);
  const [toggle, settoggle] = useState(false);
  const handleRowDelete = (i) => {
    setDeleteState(true);
    settoggle(true);
  };

  return (
    <>
      <tr className={el["Name"] === "Total Bill Amount" ? "totalRow" : ""}>
        {headers.map((e) => {
          if (e === "Expense_Account") {
            return <td>{el[e] && el[e].Account_Name}</td>;
          }
          if (e === "Amount") {
            return <td className="numberColumn">{el[e] === "NaN" || el[e] === NaN ? 0 : el[e]}</td>;
          }
          if (e === "Transaction_Type") {
            return <td>{el[e]}</td>;
          }
          return (
            <td className={e === "Rate" || e === "Amount" ? "numberColumn" : ""} key={Math.random() * 10}>
              {el[e] === "NaN" || el[e] === NaN ? 0 : el[e]}
            </td>
          );
        })}
        {/* {el.Name !== "Taxable Amount" && el.Name !== "Total Bill Amount" ? (
          <td onClick={() => handleRowDelete(el._id)}>
            <MdDelete />
          </td>
        ) : (
          <td></td>
        )} */}
      </tr>
      <>
        {deleteState ? (
          <Confirm
            toggle={toggle}
            settoggle={settoggle}
            submit={() => {
              handleDelete(el._id);
              settoggle(false);
              setDeleteState(false);
            }}
          />
        ) : (
          ""
        )}
      </>
    </>
  );
};
